import React, { useState, useEffect } from 'react';

import { Flex, Skeleton } from '@chakra-ui/react';
import { useTimelineDataQuery } from 'Deer/intent/Reviews/hooks/useTimelineDataQuery';
import { useSelectReviewsSelectedForm } from 'Deer/intent/Reviews/slice/ReviewsIntentSlice';
import { checkIntentLandingPagesFeatureEnabled } from 'utils/helpers/featureFlags';

import { getReviewHelpTimelineV1 } from 'services/performanceReview';

import { PaperWithShadow } from 'uiToolkitV1/Paper';
import { ReviewTimeline } from 'uiToolkitV1/ReviewTimeline';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import StyledSelect from './ReviewManageTimeline.styles';

function ReviewManageTimelineNonIntent({ selectedReviewCycle }) {
  const [timelineData, setTimelineData] = useState([]);
  const [timelineLoading, setTimelineLoading] = useState(false);
  const [selectedForm, setSelectedForm] = useState(null);

  const fetchTimelineData = (selectedReviewCycle1) => {
    setTimelineLoading(true);

    getReviewHelpTimelineV1({ reviewCycleId: selectedReviewCycle1.uuid })
      .then((res) => {
        setTimelineData(res);
        setSelectedForm(res[0]);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setTimelineLoading(false);
      });
  };

  useEffect(() => {
    if (selectedReviewCycle) {
      fetchTimelineData(selectedReviewCycle);
    }
  }, [selectedReviewCycle]);

  const selectedTimelineData =
    timelineData.find(({ feedbackFormId }) => selectedForm?.feedbackFormId === feedbackFormId)?.feedbackTimelines ?? [];

  if (selectedTimelineData.length === 0) return null;

  return (
    <PaperWithShadow p={4} mb={3}>
      <Flex justifyContent="space-between" alignItems="center" mb={4}>
        <TextBodyMedium bold color="text.g2" ml="5px">
          Timeline - {selectedReviewCycle?.displayName}
        </TextBodyMedium>
        {timelineData?.length > 0 ? (
          <Flex alignItems="center">
            <TextBodyMedium bold color="text.g2" minWidth="105px">
              View Name:
            </TextBodyMedium>
            <StyledSelect
              name="reviewForm"
              placeholder="Select Review Cycle"
              value={selectedForm}
              options={timelineData || []}
              getOptionValue={(option) => option.feedbackFormId}
              getOptionLabel={(option) => option.name}
              handleChange={setSelectedForm}
              withBackground={false}
            />
          </Flex>
        ) : null}
      </Flex>
      <Skeleton isLoaded={!timelineLoading}>
        {selectedTimelineData.length > 0 ? <ReviewTimeline timelineData={selectedTimelineData} /> : null}
      </Skeleton>
    </PaperWithShadow>
  );
}

const ReviewManageTimelineIntent = ({ selectedReviewCycle }) => {
  const { data: timelineData, isLoading } = useTimelineDataQuery({
    selectedReviewCycle,
  });

  const selectedForm = useSelectReviewsSelectedForm();

  const selectedTimelineData =
    timelineData?.find(({ feedbackFormId }) => selectedForm?.feedbackFormId === feedbackFormId)?.feedbackTimelines ??
    [];

  if (selectedTimelineData.length === 0) return null;

  return (
    <PaperWithShadow p={4} mb={3}>
      <Flex justifyContent="space-between" alignItems="center" mb={4}>
        <TextBodyMedium bold color="text.g2" ml="5px">
          Timeline - {selectedReviewCycle?.displayName}
        </TextBodyMedium>
      </Flex>
      <Skeleton isLoaded={!isLoading}>
        {selectedTimelineData.length > 0 ? <ReviewTimeline timelineData={selectedTimelineData} /> : null}
      </Skeleton>
    </PaperWithShadow>
  );
};

const ReviewManageTimeline = ({ selectedReviewCycle }) => {
  if (checkIntentLandingPagesFeatureEnabled()) {
    return <ReviewManageTimelineIntent selectedReviewCycle={selectedReviewCycle} />;
  }
  return <ReviewManageTimelineNonIntent selectedReviewCycle={selectedReviewCycle} />;
};

export default ReviewManageTimeline;
